export function formatNumber(num: number | string): string {
  if (typeof num === 'string') {
    num = parseFloat(num);
  }
  return num.toLocaleString('en-US', { maximumFractionDigits: 2 });
}
